<!-- Hero Section -->
<section class="hero-section">
  <div class="hero-content">

    <h1>Welcome to Builtgenix</h1>
    <p class="hero-subtitle">Streamline your business operations with our comprehensive enterprise solutions</p>
    <p class="hero-subtitle-2">Unlock the full potential of your business with Builtgenix</p>
    <div class="hero-buttons">
      <a href="/login" class="btn-primary">
        <span>Get Started</span>
        <i class="bi bi-arrow-right"></i>
      </a>
      <a href="https://www.builtgenix.com/" class="btn-secondary" target="_blank">Learn More</a>
    </div>
  </div>
</section>

<!-- Features Section -->
<section class="features-section">
  <div class="features-grid">
    <div class="feature-card">
      <div class="feature-icon">
        <i class="bi bi-file-earmark-text"></i>
      </div>
      <h3>Document Management</h3>
      <a href="https://www.builtgenix.com/" target="_blank" rel="noopener noreferrer" class="feature-more-btn">Learn more</a>
    </div>
    <div class="feature-card">
      <div class="feature-icon">
        <i class="bi bi-chat-dots"></i>
      </div>
      <h3>Real-time Communication</h3>
      <a href="https://www.builtgenix.com/" target="_blank" rel="noopener noreferrer" class="feature-more-btn">Learn more</a>
    </div>
    <div class="feature-card">
      <div class="feature-icon">
        <i class="bi bi-diagram-3"></i>
      </div>
      <h3>BOM Management</h3>
      <a href="https://www.builtgenix.com/" target="_blank" rel="noopener noreferrer" class="feature-more-btn">Learn more</a>
    </div>
    <div class="feature-card">
      <div class="feature-icon">
        <i class="bi bi-bar-chart"></i>
      </div>
      <h3>Advanced Analytics</h3>
      <a href="https://www.builtgenix.com/" target="_blank" rel="noopener noreferrer" class="feature-more-btn">Learn more</a>
    </div>
  </div>
</section>

<!-- Bento Grid Layout -->
<div class="bento-grid row">
  <!-- Email Contact Card -->
  <div class="bento-card contact-card col-md-4 col-sm-6 col-12">
    <div class="card-icon">
      <i class="bi bi-envelope-fill"></i>
    </div>
    <h3>Email Us</h3>
    <a href="mailto:info@builtgenix.com" class="contact-link">info&#64;builtgenix.com</a>
    <p class="subtitle">We typically respond within 24 hours.</p>
  </div>

  <!-- Phone Contact Card -->
  <div class="bento-card contact-card">
    <div class="card-icon">
      <i class="bi bi-telephone-fill"></i>
    </div>
    <h3>Call Us</h3>
    <a href="tel:3129700336" class="contact-link">312-970-0336</a>
    <p class="subtitle">Monday - Friday, 9:00 AM - 6:00 PM EST</p>
  </div>

  <!-- LinkedIn Card -->
  <div class="bento-card linkedin-card ">
    <h3>Follow us on LinkedIn</h3>
    <a href="https://www.linkedin.com/company/builtgenix/" target="_blank" class="linkedin-icon">
      <i class="bi bi-linkedin"></i>
    </a>
  </div>
</div>

